import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  /**
   * @this
   * @representationOfSteps
   * 0: notActive,
   * 1: trigger homepage lucky button (timeout 2.5? => alex?),
   * 2: trip screen blocked (timer text start, android (2.5s)? ) + deactivate quickInfo sections + body block scroll,
   * 3: Destination onboarding start (price hidden),
   * 4: Accommodation onboarding,
   * 5: Activity onboarding,
   * 6: Price onboarding,
   * 7: activate quickInfo sections + timer for filters screen (alex?).
   * 8: show filters + lower section onboarding {budget slider lower text @animation2} + body unblock scroll {it will end here}.
   * 9: after click lucky in filters component remove budgetSlider onboarding => endOnboardingJourney {0}.
   * @animation always fade out previous step, and fade in next.
   * @animation2 pulse or indication on lucky button.
   * @
   */
  public onboardingStep = new BehaviorSubject(0);
  public onboardingCurrentStep = this.onboardingStep.asObservable();
  public isOnboardingActive: boolean = this.configService.isOnboardingActive();

  constructor(
    private configService: ConfigService,
    private router: Router,
    @Inject(PLATFORM_ID) private platform: Object,
  ) { }

  startOnboarding() {
    this.resetOnboardingStep();
    this.router.navigate(['/']);
    this.lockWindowScroll();
  }

  resetOnboardingStep() {
    this.onboardingStep.next(1);
  }

  setOnboardingStep(step: number) {
    this.onboardingStep.next(step);
  }

  goToNextStep() {
    let _currentStep = this.onboardingStep.getValue();
    if (_currentStep && _currentStep > 11) {
      this.onboardingStep.next(0);
    } else {
      _currentStep = _currentStep + 1;
      this.onboardingStep.next(_currentStep);
    }
    switch (_currentStep) {
      case 11:
        this.unlockWindowScroll();
        this.killOnboardingJourney();
        break;
      default:
        break;
    }
  }

  lockWindowScroll() {
    if (isPlatformBrowser(this.platform)) {
      const _bodyElement = <HTMLBodyElement>document.body;
      if (_bodyElement) {
        _bodyElement.classList.add('onboardingJourney');
      }
    }
  }

  unlockWindowScroll() {
    if (isPlatformBrowser(this.platform)) {
      const _bodyElement = <HTMLBodyElement>document.body;
      if (_bodyElement) {
        _bodyElement.classList.remove('onboardingJourney');
      }
    }
  }

  killOnboardingJourney() {
    this.isOnboardingActive = false;
    this.configService.changeOnboardingValue();
    this.onboardingStep.next(0);
    this.unlockWindowScroll();
  }

}
